export const usePagination = ({ currentPage, perPage, currentItemsCount, allItemsCount}) => {
  const pages = allItemsCount < +perPage ? 1 : Math.ceil(allItemsCount / +perPage)
  const from = currentPage === 1 ? currentPage : (currentPage - 1) * +perPage + 1
  const to = currentPage < pages ? from + +perPage - 1 : allItemsCount

  return {
    currentPage,
    pages,
    from,
    to,
    pageItems: currentItemsCount,
    totalItems: allItemsCount
  }
}
